export default {
  'zh-CN': {
    common: {
      loading: '加载中...',
      nodata: '未查询到数据',
      errorTip: '获取数据失败，请重试',
      delFailed: '删除失败，请重试',
      updateFailed: '更新失败，请重试',
      fail: '操作失败！',
      input: '请输入',
      hide: '隐藏',
      show: '显示',
      copy: '复制',
      suc: '成功',
      send: '发送',
      contain: '包含',
      nocontain: '不包含',
      yes: '是',
      no: '否',
      certain: '确定',
      cancel: '取消',
      save: '保存',
      search: '搜索',
      noSave: '设置内容尚未保存！',
      isLeave: '如果现在离开，系统将放弃所做的配置或修改，是否确认离开当前页面？',
      channelNameLength: '渠道名称为0-16位中文、字母、数字、下划线、中划线，请重新输入',
    },
    filter: {
      week: '最近一周',
      month: '最近一个月',
      threeMonth: '最近三个月',
      halfYear: '最近半年',
      oneYear: '最近一年',
      conditions: '筛选',
      choose: '选择',
      partner: '渠道',
      usergroup: '用户分群',
      version: '版本',
      clear: '清空',
      confirm: '确认',
      cancel: '取消',
      search: '搜索',
      all: '全选',
      err: '至少需选择一种平台！',
      supportUserGroup: '系统暂不支持所选指标或指标组合进行分群分析',
    },
  },
  'en-US': {
    common: {
      loading: 'Loading...',
      nodata: 'Not found any data',
      fail: 'Operation Failed!',
      errorTip: 'Failed to get data,please try again',
      delFailed: 'Failed to delete,please try again',
      updateFailed: 'Failed to update,please try again',
      input: 'Please Enter...',
      hide: 'Hide',
      show: 'Show',
      copy: 'Copy',
      suc: 'Successfully!',
      send: 'Send',
      contain: 'Include',
      nocontain: 'Exclude',
      yes: 'Yes',
      no: 'No',
      certain: 'Ensure',
      cancel: 'Cancel',
      save: 'Save',
      noSave: 'You have unsaved changes!',
      search: 'Search',
      isLeave: 'If you leave before saving, your changes will be lost.Are you sure you want to leave this page?',
      channelNameLength: 'The channel name should be less than 16 characters Chinese, letter, number, underline, please re-enter.',
    },
    filter: {
      week: 'Last week',
      month: 'Last month',
      threeMonth: 'Last 3 months',
      halfYear: 'Last half year',
      oneYear: 'Last year',
      conditions: 'Filter',
      choose: 'Choose ',
      partner: 'Channels',
      usergroup: 'Segments',
      version: 'Version',
      clear: 'Clear',
      confirm: 'Confirm',
      cancel: 'Cancel',
      search: 'Search',
      all: 'All',
      err: 'One Platform At Least！',
      supportUserGroup: 'Unable to select this property',
    },
  },
};

